import { APP_INITIALIZER } from '@angular/core';
import { configureAmplify } from './amplify.config';

/**
 * Provider that initializes Amplify when the application starts
 */
export const amplifyProvider = {
  provide: APP_INITIALIZER,
  useFactory: () => {
    return () => {
      // Configure Amplify when the application starts
      configureAmplify();
      console.log('Amplify configured for AppSync');
    };
  },
  multi: true
};
